export default {
    big:   'big',
    small: 'small',
};